<template>
  <!--Careers -->
  <div class="landing-careers" v-if="pageCareers.elements">
    <hero :props="pageCareers.elements" :heroHome="true"></hero>
    <div class="collage-bg">
      <section class="careers-info container" id="section">
      <div class="inside">
        <h3 class="title-medium" v-if="pageCareers.elements.description_title">
          {{ pageCareers.elements.description_title.value }}
        </h3>
        <div
          v-if="pageCareers.elements.description_text"
          v-html="pageCareers.elements.description_text.value"
        ></div>
        <a href="/jobs" target="_blank"
          ><button type="button" class="btn_orange">Check our Open Positions</button></a
        >
      </div>
    </section>
    <!-- Benefits -->
    <section>
      <div class="container-fluid">
        <h3 class="title-medium small-wrapper text-center">Our commitment to you includes:</h3>
        <ul class="benefits">
          <li><span class="num"></span>Flexible Time Off</li>
          <li><span class="num gold"></span>Hybrid Or Remote Work</li>
          <li><span class="num purple"></span>Medical Benefits</li>
          <li><span class="num green"></span>Work Equipment Provided</li>
          <li><span class="num"></span>Development and Bonuses</li>
          <li><span class="num gold"></span>Travel Opportunities</li>
          <li><span class="num purple"></span>Facilities In-Office</li>
          <li><span class="num green"></span>Connectivity Benefits</li>
          <li><span class="num"></span>Wellness Benefits</li>
          <li><span class="num gold"></span>Milestones Recognition</li>
          <li><span class="num purple"></span>English Classes (LATAM)</li>
        </ul>
      </div>
      <div class="small-wrapper comments">
          <p>*Note: We have benefits and perks that are specific to the type of employment and location.</p>
          <p>This will be explained in depth during the screening interview.</p>
        </div>
    </section>
    <!-- End Benefits -->
    </div>
    <section class="careers-slider">
      <carousel
        id="slider-dektop"
        class="hidden-xs"
        :navigationEnabled="false"
        :navigationNextLabel="''"
        :navigationPrevLabel="''"
        :perPage="1"
        :paginationActiveColor="'#8E4C3B'"
        :paginationColor="'#dedede'"
        :navigationClickTargetSize="5"
        :paginationPadding="5"
        :paginationSize="10"
        v-in-viewport="{}"
      >
        <template
          class="image-slider"
          v-if="videosSliders.length"
          v-for="slide in videosSliders"
        >
          <slide>
            <div class="embed-container">
              <iframe
                :src="
                  'https://player.vimeo.com/video/' +
                  slide.vimeo_id.value +
                  '?loop=1&title=0&byline=0&portrait=0'
                "
                width="640"
                height="360"
                frameborder="0"
                allow="autoplay; fullscreen"
                allowfullscreen
              ></iframe>
            </div>
          </slide>
        </template>

        <template
          class="image-slider"
          v-if="careersSliders.length"
          v-for="slide in careersSliders"
        >
          <slide
            :style="setBackgroundImage(slide.background_image___desktop.value[0].url)"
          >
            <div class="inside">
              <div class="copy" v-in-viewport="">
                <h3>{{ slide.title.value }}</h3>
                <p v-in-viewport="{}">{{ slide.description.value }}</p>
              </div>
            </div>
            <div class="gradient"></div>
            <img
              :src="slide.background_image___desktop.value[0].url"
              :alt="slide.background_image___desktop.value[0].name"
            />
          </slide>
        </template>
      </carousel>
      <carousel
        id="slider-mobile"
        class="visible-xs"
        :navigationEnabled="false"
        :navigationNextLabel="''"
        :navigationPrevLabel="''"
        :perPage="1"
        :paginationActiveColor="'#8E4C3B'"
        :paginationColor="'#dedede'"
        :navigationClickTargetSize="5"
        :paginationPadding="5"
        :paginationSize="10"
        v-in-viewport="{}"
      >
        <template
          class="image-slider"
          v-if="videosSliders.length"
          v-for="slide in videosSliders"
        >
          <slide>
            <div class="embed-container">
              <iframe
                :src="
                  'https://player.vimeo.com/video/' +
                  slide.vimeo_id.value +
                  '?loop=1&title=0&byline=0&portrait=0'
                "
                width="640"
                height="360"
                frameborder="0"
                allow="autoplay; fullscreen"
                allowfullscreen
              ></iframe>
            </div>
          </slide>
        </template>

        <template
          class="image-slider"
          v-if="careersSliders.length"
          v-for="slide in careersSliders"
        >
          <slide
            :style="setBackgroundImage(slide.background_image___mobile.value[0].url)"
          >
            <div class="copy" v-in-viewport="">
              <h3>{{ slide.category.value }}</h3>
              <h2>{{ slide.title.value }}</h2>
              <p>{{ slide.description.value }}</p>
            </div>
            <div class="gradient"></div>
            <img
              :src="slide.background_image___mobile.value[0].url"
              :alt="slide.background_image___mobile.value[0].name"
            />
          </slide>
        </template>
      </carousel>
    </section>

    <section
      class="content-section detail-page"
      v-in-viewport=""
      v-if="pageCareers.elements"
    >
      <div class="inside" v-html="pageCareers.elements.detail_page.value"></div>
    </section>

    <section class="content-articles" v-in-viewport="">
      <div class="inside">
        <h2
          class="text-center container"
          v-in-viewport=""
          v-if="pageCareers.elements.related_words_title"
        >
          {{ pageCareers.elements.related_words_title.value }}
        </h2>
        <p
          class="text-center container"
          v-in-viewport=""
          v-if="pageCareers.elements.related_words_description"
        >
          {{ pageCareers.elements.related_words_description.value }}
        </p>
        <articles-wrapper
          :boxes="relatedWorks"
          :isHome="true"
          :boxlimit="4"
          :pathRoute="'/words'"
          :showCategory="true"
          :showViewAll="true"
        ></articles-wrapper>
      </div>
    </section>

    <section class="content-quote container-fluid col-xs-12" v-if="quote.elements">
      <div class="inside">
        <div class="quote-text text-center" v-in-viewport="">
          "{{ quote.elements.quote_text.value }}"
          <span class="author">{{ quote.elements.author.value }} </span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
require("../assets/img/arrow-left.svg");
require("../assets/img/arrow-right.svg");

import apiConnection from "../mixins/apiConnection.js";
import seoModule from "../mixins/seoModule.js";
import hero from "../components/hero.vue";
import articlesWrapper from "../components/articles-wrapper.vue";
import porfolio from "../components/porfolio.vue";
import { Carousel, Slide } from "vue-carousel";
import commons from "../mixins/common.js";

export default {
  name: "Careers",
  data() {
    return {
      pageCareers: [],
      careersSliders: [],
      articles: [],
      relatedWorks: [],
      quote: [],
      videosSliders: [],
    };
  },
  created: function () {
    this.getCareers();
    setTimeout(function () {
      var w_desktop = $("#slider-dektop .VueCarousel-dot-container").width();
      $("#slider-dektop .VueCarousel-navigation-prev").css(
        "left",
        "calc(50% - " + (w_desktop / 2 + 20) + "px )"
      );
      $("#slider-dektop .VueCarousel-navigation-next").css(
        "right",
        "calc(50% - " + (w_desktop / 2 + 20) + "px )"
      );

      var w_mobile = $("#slider-mobile .VueCarousel-dot-container").width();
      $("#slider-mobile .VueCarousel-navigation-prev").css(
        "left",
        "calc(50% - " + (w_mobile / 2 + 20) + "px )"
      );
      $("#slider-mobile .VueCarousel-navigation-next").css(
        "right",
        "calc(50% - " + (w_mobile / 2 + 20) + "px )"
      );
    }, 1500);
    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    setTimeout(function () {
      $(".st-sticky-share-buttons").addClass("st-sticky-share-buttons-show");
    }, 1500);
  },
  components: {
    hero: hero,
    "articles-wrapper": articlesWrapper,
    Carousel,
    Slide,
  },
  mixins: [apiConnection, commons, seoModule],
  methods: {
    handleResize: function () {
      var w_desktop = $("#slider-dektop .VueCarousel-dot-container").width();
      $("#slider-dektop .VueCarousel-navigation-prev").css(
        "left",
        "calc(50% - " + (w_desktop / 2 + 20) + "px )"
      );
      $("#slider-dektop .VueCarousel-navigation-next").css(
        "right",
        "calc(50% - " + (w_desktop / 2 + 20) + "px )"
      );

      var w_mobile = $("#slider-mobile .VueCarousel-dot-container").width();
      $("#slider-mobile .VueCarousel-navigation-prev").css(
        "left",
        "calc(50% - " + (w_mobile / 2 + 20) + "px )"
      );
      $("#slider-mobile .VueCarousel-navigation-next").css(
        "right",
        "calc(50% - " + (w_mobile / 2 + 20) + "px )"
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// Careers.vue?de8cf84c